import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import {Pie} from 'react-chartjs-2'
import {HorizontalBar} from 'react-chartjs-2';

//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import { Divider, Hidden } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import config from "../../config/config";
import axios from 'axios';

import { grid_spacing } from '../CSS/Styles';
import CustomizedTable from '../CSSComponent/table'
import CustomizedCard from '../CSSComponent/card'
import {card} from '../CSS/card'

const styles = {...card}



const StyledTableCell = withStyles({
    root:{
        paddingRight: 4,
        paddingLeft: 12,
        paddingTop: 0,
        paddingBottom: 0
    },
})(TableCell);

const StyledTableRow = withStyles({
    root:{
        height: '36px',

    },
})(TableRow);

class SimpleTableTest extends Component{
    constructor(props) {
		super(props);
        // this.state = {
        //     headers:0
        // }
    }
    render(){
        const { classes } = this.props;

        const data = {
            headers:["Test Name","No. of Alerts"],
            items:[
                {name:"[#03] Tender bidders with same directors/owners",
                number:136},
                {name:"[#03] Vendors with same directors",
                number:6},
                {name:"[#04] Tender bidders with same contact persons",
                number:354},
                {name:"[#05] Exact Vendor Address, different vendor name",
                number:33},
                {name:"[#06] Exact Vendor Name",
                number:15},
                {name:"[#07] Exact Vendor Phone, different vendor name",
                number:17},
                {name:"[#08] Exact Bank Account Number, different vendor name",
                number:2},
                {name:"[#10] Tenders with opening period less than MOP",
                number:173},
            ]
        }
        const tableHeaderMap = {
            "Test Name":"name",
            "No. of Alerts":"number"
        }
        return (
            <CustomizedTable
                tableHeader={data.headers}
                data={data.items}
                tableHeaderMap={tableHeaderMap}
                tableStyle={'compact'}
            />
        )
    }
}

class SimpleTableStatus extends Component{
    constructor(props) {
		super(props);
        // this.state = {
        //     headers:0
        // }
    }
    render(){
        const { classes } = this.props;

        const data = {
            headers:["No. of Days Since Creation",
                    "No. of Days Since Last Action",
                    "Status",
                    "Date Created",
                    "Date Last Modified",
                    "Modified By",
                    "Assigned To",
                    "No. of Alerts",],
            items:[
                {id:1,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"New",
                created_date:"18/6/2018",
                modifield_date:"18/6/2018",
                modified_by: "Carol Hardacre",
                assigned_to:"Micchelle Davies",
                num_of_alerts: 2},
                {id:2,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"New",
                created_date:"18/6/2018",
                modifield_date:"18/6/2018",
                modified_by: "Colin Piper",
                assigned_to:"Piers Vance",
                num_of_alerts: 2},
                {id:3,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"New",
                created_date:"1/2/2018",
                modifield_date:"25/5/2018",
                modified_by: "Jennifer Sanderson",
                assigned_to:"Piers Vance",
                num_of_alerts: 2},
                {id:4,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"New",
                created_date:"1/2/2018",
                modifield_date:"25/5/2018",
                modified_by: "Jennifer Sanderson",
                assigned_to:"Piers Vance",
                num_of_alerts: 2}, 
                {id:5,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"New",
                created_date:"1/2/2018",
                modifield_date:"25/5/2018",
                modified_by: "Jennifer Sanderson",
                assigned_to:"Piers Vance",
                num_of_alerts: 2},
                {id:6,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"Investigating",
                created_date:"1/2/2018",
                modifield_date:"25/5/2018",
                modified_by: "Jennifer Sanderson",
                assigned_to:"Karen Ferguson",
                num_of_alerts: 2},
                {id:7,
                days_since_creation:"More than 90 days",
                days_since_action:"More than 90 days",
                status:"Investigating",
                created_date:"1/2/2018",
                modifield_date:"6/6/2018",
                modified_by: "Jennifer Sanderson",
                assigned_to:"Dorothy Welch",
                num_of_alerts: 2},             
            ]
        }
        const tableHeaderMap={
            "No. of Days Since Creation":"days_since_creation",
            "No. of Days Since Last Action":"days_since_action",
            "Status":"status",
            "Date Created":"created_date",
            "Date Last Modified":"modifield_date",
            "Modified By":"modified_by",
            "Assigned To":"assigned_to",
            "No. of Alerts":  "num_of_alerts" 
        }
        return (
            <CustomizedTable
                tableHeader={data.headers}
                data={data.items}
                tableHeaderMap={tableHeaderMap}
                tableStyle={'compact'}
            />
        )
    }
}

SimpleTableStatus.propTypes = {
    classes: PropTypes.object.isRequired,
};

SimpleTableStatus = withStyles(styles)(SimpleTableStatus);

class AlertSummary extends Component {
    constructor(props) {
		super(props);
        this.state = {
            value:0
        }
    }

    handleChange = (event, value) => {
         this.setState({ value });
    };

    getTasks(){
        axios.get(config.task)
        .then(res => {
            let tasks = res.data;
            let task_data = []
            task_data.push(tasks.filter(task=>task.status=='Draft').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Response').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Review').length)
            task_data.push(tasks.filter(task=>task.status=='Rejected').length)
            task_data.push(tasks.filter(task=>task.status=='Completed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Draft',
                'Pending Response',
                'Pending Review',
                'Rejected',
                'Completed'
                ],
                datasets:[{
                    data:task_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                taskStatusData: data
            })
        })
    }
    getAlerts(){
        axios.get(config.allAlerts)
        .then(res => {
            let alerts = res.data;
            let alert_data = []
            alert_data.push(alerts.filter(alert=>alert.status=='Open').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Investigating').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Review').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Approval For Closure').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Closed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Open',
                'Investigating',
                'Pending Review',
                'Pending Approval For Closure',
                'Closed'
                ],
                datasets:[{
                    data:alert_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                alertStatusData: data
            })
        })
    }
    getInitialState() {
    }

    componentDidMount(){
    }

    componentWillMount() {
    }
    render() {
        const { classes } = this.props;

        const data={
            labels: [
            'Open',
            'Investigating',
            'Pending Review',
            'Pending Approval For Closure',
            'Closed'
            ],
            datasets:[{
                data:[23,45,0,12,2086],
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#990099',
                    '#ff9900'
                    ],
                    hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56',
                    '#FF6384',
                    '#36A2EB'
                    ]
            }]
        };

        const data_action = {
            labels: ['More than 90 days', '61 to 90 days', '31 to 60 days', '0 to 30 days', 'Closed'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [774, 18, 7, 1360, 2]
              }
            ]
        };

        const data_report = {
            labels: ['More than 90 days', '61 to 90 days', '31 to 60 days', '0 to 30 days', 'Closed'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [774, 18, 7, 1360, 2]
              }
            ]
        };


        return (
            <div flexGrow={1}>
                <Grid container spacing={grid_spacing}>
                    <Grid item xs={4}>
                        <CustomizedCard
                            header={"Total No. of Alerts"}
                            subheader={["from 1/2/2018 to 3/10/2018"]}
                            contentText={["2164"]}
                            cardStyle={"veryShort"}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <CustomizedCard
                            header={"Total No. of Closed Alerts"}
                            subheader={["from 1/2/2018 to 3/10/2018"]}
                            contentText={["2086"]}
                            cardStyle={"veryShort"}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <CustomizedCard
                            header={"Total No. of Open Alerts"}
                            subheader={["from 1/2/2018 to 3/10/2018"]}
                            contentText={["78"]}
                            cardStyle={"veryShort"}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Card className={classes.card_1_3rd}>
                            <SimpleTableTest/>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card className={classes.card_1_3rd}>
                            <div >
                                <div className={classes.cardHeader}>
                                    <Typography variant="h5">
                                        No. of Days Since Last Action
                                    </Typography>
                                </div>
                                <CardContent>
                                    <HorizontalBar height={200} data={data_action} options={{
                                        maintainAspectRatio: false,
                                        plugins: {
                                            datalabels: {
                                                display: false
                                            }
                                        },
                                        title:{
                                            display:false,
                                            text: "No. of Days Since Last Action",
                                        },
                                        legend:{
                                            position:"bottom",
                                        }
                                    }}/>
                                </CardContent>
                            </div>
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Card className={classes.card_1_3rd}>
                            <div >
                                <div className={classes.cardHeader}>
                                    <Typography variant="h5">
                                        No. of Days Since Last Report
                                    </Typography>
                                </div>
                                <CardContent>
                                    <HorizontalBar height={200} data={data_report} options={{
                                        maintainAspectRatio: false,
                                        plugins: {
                                            datalabels: {
                                                display: false
                                            }
                                        },
                                        title:{
                                            display:false,
                                            text: "No. of Days Since Last Report",
                                        },
                                        legend:{
                                            position:"bottom",
                                        }
                                    }}/>
                                </CardContent>
                            </div>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.card_1_3rd}>
                            <SimpleTableStatus/>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(AlertSummary);


// WEBPACK FOOTER //
// ./src/components/Dashboard/AlertSummary.js